import { Button } from "@chakra-ui/button";
import { Image } from "@chakra-ui/image";
import { Flex, Text } from "@chakra-ui/layout";
import { Table, Td, Th, Thead, Tr } from "@chakra-ui/table";
import { useState } from "react";
import { CardItem } from "./CardItem";


export function Items({ itens, refetch }) {

  return (
    <Table>
      <Thead bg="#7fbc03" color="white">
        <Tr
          sx={{
            "th, td": {
              color: "white",
            },
          }}
        >
          <Th>Item</Th>
          <Th textAlign="center">Qtd.</Th>

          <Th textAlign="center">Valor unitário</Th>
          <Th textAlign="center">Valor total</Th>
          <Th textAlign="center">Layout</Th>
        </Tr>
      </Thead>
      {itens?.map((item, index) => (
        <CardItem key={index} item={item} index={index} refetch={refetch} />
      ))}
    </Table>
  );
}
